import { Injectable } from '@angular/core';

@Injectable()
export class ContainService {

  instant(array: any[], searchString: string, fields?: string[]): any[] {
    if (!searchString) {
      return [];
    }
    if (!fields || fields.length === 0 ) {
      return  array.filter(elem => elem.indexOf(searchString) > -1);
    }
    return array.filter(elem => {
      return fields.filter(
        field => elem[field].indexOf(searchString) > -1
      ).length > 0;
    });
  }
}
